// action
import {
    SAVE_APPOINTMENT_COMPLETE_STATUS,
    SAVE_APPOINTMENT_COMPLETE_STATUS_FAIL,
    SAVE_APPOINTMENT_COMPLETE_STATUS_SUCCESS,
    SAVE_APPOINTMENT_COMPLETE_STATUS_RESET
} from '../action/saveAppointmentCompleteStatusAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_APPOINTMENT_COMPLETE_STATUS:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_APPOINTMENT_COMPLETE_STATUS_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_APPOINTMENT_COMPLETE_STATUS_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_APPOINTMENT_COMPLETE_STATUS_RESET:
            return initialState
        default:
            return state
    }
}